import ModalConfirmDockFresh from './ModalConfirmDockFresh'

export default ModalConfirmDockFresh
